module.exports = __webpack_public_path__ + "static/media/disabled-award.3b0c37f5.jpg";